import NovalueCheck from './NoValueCheck';

export default (value) => {
  if(NovalueCheck(value)) return NovalueCheck(value);

  value = +value;

  // เกณฑ์ BMI สำหรับคนเอเชีย (แนะนำโดย WHO)
  // ปกติ: 18.5-22.9
  // น้ำหนักเกิน: 23-24.9
  // อ้วน: >= 25

  if(value >= 40) {
    return {
      title: 'อ้วนมากระดับวิกฤติ',
      color: 'red',
      caption: 'มีภาวะอ้วนระดับวิกฤต',
      suggest: 'จำเป็นต้องลดน้ำหนักภายใต้การดูแลของแพทย์'
    };
  } else if(value >= 30) {
    return {
      title: 'อ้วนมาก',
      color: 'red',
      caption: 'มีภาวะอ้วน',
      suggest: 'จำเป็นต้องลดน้ำหนักภายใต้การดูแลของแพทย์'
    };
  } else if(value >= 25) {
    return {
      title: 'อ้วน',
      color: 'red',
      caption: 'มีภาวะอ้วน',
      suggest: 'ควรลดน้ำหนักและออกกำลังกาย'
    };
  } else if(value >= 23) {
    return {
      title: 'น้ำหนักเกิน',
      color: 'red', // เปลี่ยนจาก yellow เป็น red (ระบบรองรับ 3 สีเท่านั้น)
      caption: 'เริ่มมีน้ำหนักเกินเกณฑ์ปกติ',
      suggest: 'เริ่มควบคุมอาหารและออกกำลังกาย'
    };
  } else if(value >= 18.5) {
    return {
      title: 'น้ำหนักปกติ',
      color: 'green',
      caption: 'น้ำหนักอยู่ในเกณฑ์ปกติ',
      suggest: 'รับประทานอาหารและออกกำลังกายตามปกติ'
    };
  } else if(value >= 17) {
    return {
      title: 'น้ำหนักน้อย',
      color: 'red', // เปลี่ยนจาก yellow เป็น red
      caption: 'น้ำหนักน้อยกว่าเกณฑ์ปกติ',
      suggest: 'ควรประเมินภาวะทุพโภชนาการและให้การรักษา'
    };
  } else if(value >= 16) {
    return {
      title: 'น้ำหนักน้อยเกินไป',
      color: 'red',
      caption: 'น้ำหนักน้อยกว่าเกณฑ์ปกติปานกลาง',
      suggest: 'ควรประเมินภาวะทุพโภชนาการและให้การรักษา'
    };
  } else {
    return {
      title: 'น้ำหนักน้อยระดับวิกฤติ',
      color: 'red',
      caption: 'น้ำหนักน้อยกว่าเกณฑ์ปกติมาก',
      suggest: 'ควรประเมินภาวะทุพโภชนาการและให้การรักษา'
    };
  }
}